module.exports = __webpack_public_path__ + "static/media/havana-2.b808fe45.jpg";